import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Display a quantity / weight / pack count to 2 decimal places.
 * Null / undefined / empty are rendered as the supplied `fallback` (default "—").
 */
export function fmt2(value, fallback = "—") {
  if (value === null || value === undefined || value === "") return fallback;
  const n = Number(value);
  return Number.isFinite(n) ? n.toFixed(2) : fallback;
}

